import IPage from "../../../interfaces/page";
import MainLayout from "../../layouts/Main/Main.layout";
import RegisteredUsersComponent from '../../Components/RegisteredUsers/RegisteredUsers.component'

const RegisteredUsersPage: React.FC<IPage> = () => {
    return <MainLayout component={RegisteredUsersComponent} />
}

export default RegisteredUsersPage;